import { FC, useState } from 'react';
import { Box } from '@mui/material';
import Autocomplete from 'view/components/Autocomplete';
import { Button, CompanyAvatar } from 'view/components';
import { useGetCompaniesForRecruiter } from 'view/pages/createJobPost/hooks/useGetCompaniesForRecruiter';

interface CompanySelectorProps {
  value: any;
  onChange: (company: any) => void;
  onCreateNew: () => void;
  disabled?: boolean;
}

export const CompanySelector: FC<CompanySelectorProps> = ({
  value,
  onChange,
  onCreateNew,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [page, setPage] = useState(1);

  const { data, isLoading } = useGetCompaniesForRecruiter(inputValue, page);

  return (
    <Box>
      <Autocomplete
        label="Company *"
        value={value}
        onChange={onChange}
        inputValue={inputValue}
        setInputValue={setInputValue}
        page={page}
        setPage={setPage}
        data={data}
        isLoading={isLoading}
        getOptionLabel={(option: any) => {
          return option.name || '';
        }}
        marginbottom={12}
      />

      {/* Visual confirmation of the bound company: matches the Company Memberships card — logo
          (or first-letter square fallback) + name in a white block, minus the role and actions. */}
      {value && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            p: '20px',
            bgcolor: 'white',
          }}
        >
          <CompanyAvatar company={value} />
          <Box
            sx={{
              minWidth: 0,
              fontSize: '18px',
              fontWeight: 600,
              color: '#111827',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {value.name}
          </Box>
        </Box>
      )}

      {/* Same outlined "Create New Company" affordance as the Company Memberships page. */}
      <Button
        variant="outlined"
        text="Create New Company"
        onClick={onCreateNew}
        disabled={disabled}
        style={{ minHeight: '40px', marginTop: '12px' }}
      />
    </Box>
  );
};
